const baseUrl = "/v1/admin/reports"
export const API_URL = {
    VILLAGE_REPORTS: `${baseUrl}/village-report`,
}